import workspaceQuery from 'graphql/queries/system/LoggedInUserWorkspaceQuery.graphql';

const LoggedInUser = {
  type: 'LoggedInUser',
  title: 'Logged In Users',
  workspaceUrl: '/System/LoggedInUser/Workspace/',
  workspace: workspaceQuery,
  screenReference: 'LOGGED_IN_USER',
};

export default LoggedInUser;
